import React from "react";
import styles from './FeaturedOffers.module.css'

const FeaturedOffers = ({ products }) => {
    return(
        <div className={styles.featuredOffers}>
            <div className={styles.offersGrid}>
                {products.map((products) => (
                    <div className={styles.offerCard} key={products.id}>
                        <div className={styles.offerBadge}>OFERTA</div>
                        <img 
                            src={products.primary_image}
                            alt={products.slug}
                            className={styles.offerImage}
                        />
                        <div className={styles.offerContent}>
                                <h3 className={styles.offerTitle}>Ofertas destacadas</h3>
                            <div className={styles.priceContainer}>
                                <span className={styles.currentPrice}>
                                    {products.original_price ? `Ahora: $${products.price}`: `Precio: $${products.price}`}
                                </span>
                                <span className={styles.originalPrice}>
                                {products.original_price ? `Antes: $${products.original_price}` : ''}
                                </span>
                            </div>
                            <button className={styles.buyButton}>Comprar ahora</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default FeaturedOffers